import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutBackOfficeReasonCodeList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceBackOfficeReasonCode: DataSource;
    tableBackOfficeReasonCode: Table;
}
